module.exports = __webpack_public_path__ + "static/media/certMSAIF.8f620c3b.pdf";